<template>
  <NodeViewWrapper class="video-with-tool" :class="{ 'ProseMirror-selectednode': selected }">
    <el-popover
      trigger="hover"
      placement="top"
      width="200"
      popper-class="announcement-video-width-popover"
    >
      <div class="video-width-options">
        <template v-for="(option, index) in widthOptions">
          <span
            :key="option.value"
            class="text"
            :class="{ selectedStyle: option.value === currentWidth }"
            @click="setWidth(option.value)"
            >{{ option.label }}</span
          >
          <span
            v-if="index < widthOptions.length - 1"
            :key="option.value + '-divider'"
            class="line"
          ></span>
        </template>
      </div>
      <div slot="reference" class="video-preview">
        <video
          :src="node.attrs.src"
          :poster="node.attrs.poster"
          :style="{ width: currentWidth }"
          controls
          playsinline
          preload="metadata"
          @click.stop
        ></video>
      </div>
    </el-popover>
  </NodeViewWrapper>
</template>

<script>
import { NodeViewWrapper } from '@tiptap/vue-2'
import { normalizeVideoWidth } from './videoUploadCore'

export default {
  name: 'VideoWithTool',
  components: {
    NodeViewWrapper
  },
  props: {
    node: { type: Object, required: true },
    selected: { type: Boolean, default: false },
    updateAttributes: { type: Function, required: true }
  },
  data() {
    return {
      widthOptions: [
        { label: 'Original', value: 'auto' },
        { label: '250px', value: '250px' },
        { label: '400px', value: '400px' }
      ]
    }
  },
  computed: {
    currentWidth() {
      return normalizeVideoWidth(this.node.attrs.width)
    }
  },
  methods: {
    setWidth(width) {
      this.updateAttributes({ width: normalizeVideoWidth(width) })
    }
  }
}
</script>

<style lang="less">
.announcement-video-width-popover {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid #cbd6e2;
  padding: 0;

  .video-width-options {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;

    .text {
      padding: 0 8px;
      color: #0091ae;
      font-size: 14px;
      font-family: OpenSans-Bold;
      display: inline-block;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .selectedStyle {
      color: #b0c1d4;

      &:hover {
        text-decoration: none;
      }
    }

    .line {
      height: 20px;
      display: inline-block;
      width: 1px;
      background-color: #cbd6e2;
    }
  }
}
</style>

<style scoped lang="less">
.video-with-tool {
  display: block;
  margin: 8px 0;
  max-width: 100%;

  &.ProseMirror-selectednode {
    outline: none;
  }
}

.video-preview {
  display: inline-block;
  max-width: 100%;

  video {
    display: block;
    height: auto;
    max-width: 100%;
    background: #000;
  }
}
</style>
